import {Action} from "../../../action/action";
import type {RRDate} from "@raskrask-dk/raskrask-utils";
import type {MoveBookingState} from "../moveBookingState";

export const SET_DATE = "SET_DATE";
export class SetDate extends Action<typeof SET_DATE, RRDate> {
  readonly type = SET_DATE;
  protected state: MoveBookingState;

  constructor(state: MoveBookingState, data?: RRDate) {
    super(state, data);
    this.state = state;
  }

  public isValid(): boolean {
    if (!this.data) return true;
    if (!this.isDoable()) return false;
    const {dependencies} = this.state.getData();
    if (!dependencies) return false;
    const {partner, service} = dependencies;
    const dates = partner ? partner.schedule.dates() : service.getDates([this.data]);
    const doesServiceHaveDate = dates.some((d) => this.data.equals(d));
    return doesServiceHaveDate;
  }

  public isDoable(): boolean {
    const {dependencies} = this.state.getData();
    if (!dependencies) return false;
    const isRequiredValuesSet = this.allHasValues(dependencies.service, dependencies.goal);
    return isRequiredValuesSet;
  }
}
